export * from './head.component';
